"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const LOCATION_SERVICE_URL = process.env.LOCATION_SERVICE_URL;
class LocationClient extends base_client_1.ApiClient {
    constructor(config = {
        baseURL: `${LOCATION_SERVICE_URL}/v1/`,
    }) {
        super(config);
        if (!LOCATION_SERVICE_URL) {
            commons_logs_1.log.warn("LOCATION_SERVICE_URL environment variable is not set");
        }
    }
    async getZip(ipAddress, sellerId, storeName) {
        try {
            return await this.get("zip", {
                ipAddress,
                sellerId,
                storeName,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
}
exports.LocationClient = LocationClient;
//# sourceMappingURL=LocationClient.js.map